/**
 * Toggle menu animation.
 */
export const CUBIC_BEZIER = 'cubic-bezier(.32, .94, .6, 1)';
